
import { text as post2022_10_30} from '../writings/main/2022/10/30/shortstories';
import { text as post2022_10_31} from '../writings/main/2022/10/31/shortstories';

export const text = [
  post2022_10_31,
  post2022_10_30,
]
